import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState } from 'src/entity/StateEntity';
import PharmacyDetailComponent from 'src/components/views/Mall/PharmacyDetail';

const mapStateToProps = ({ mallCategoryState: { categoryList }, mallBrandState: { brandList } }: IStoreState) => ({
  categoryList: categoryList || [],
  brandList: brandList || [],
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyDetailComponent);



// WEBPACK FOOTER //
// ./src/containers/MallPharmacyDetail.ts